import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { CheckYearField } from '../../Helpers/fieldValidator';
import { toast } from 'react-toastify';
import { makeStyles, TextField } from '@material-ui/core';
import { dataService } from '../../Services/data.service';
import { systemParameters } from '../../Config/constants';

export default function YearOfHarvest(props) {

    const [harvestYear, setHarvestYear] = useState(null)
    const classes = useStyles();

    useEffect(() => {

        dataService.getSystemParameterValueBySystemParameterId(systemParameters.YEAROFHARVEST).then(
            reply => {
                if (reply.Results.length > 0) {
                    if (JSON.stringify(harvestYear) !== JSON.stringify(reply.Results[0].Int)) {
                        setHarvestYear(reply.Results[0].Int)
                    }
                }
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, [])

    const setNextStep = () => {
        props.setContent(harvestYear);
        validate();
    }

    const validate = () => {
        let isValid = CheckYearField(harvestYear);

        if (!isValid[0]) {
            toast.error(isValid[1], { position: toast.POSITION.TOP_CENTER })
        } else {
            props.SetNext();
        }
    }

    const onChangeText = (e) => {
        setHarvestYear(e.target.value)
    }
    return (
        <div className={classes.container}>
            <TextField id="outlined-search" label="" type="number" value={harvestYear} variant="outlined" placeholder={"Enter year of harvest"} className={classes.uiTextField} size="small" onChange={(e) => onChangeText(e)} />
            <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
        </div>
    )
}

const useStyles = makeStyles({
    uiTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    container: {
        marginTop: "30px",
    }
})